import { DataManagementConfig } from '@shared/components/data-management';
import { TenantTableData, TenantFormData } from '../types';
import { AddTenantDialog } from '../components';
import {
  useTenantsQuery,
  useCreateTenantWrapper,
  useUpdateTenantWrapper,
  useDeleteTenantWrapper,
} from '../hooks/useTenantsForDataManagement';

// Factory function to create config with navigation
export const createUniversitiesConfig = (
  navigate: (path: string) => void
): DataManagementConfig<TenantTableData, TenantFormData, TenantFormData> => ({
  hooks: {
    useQuery: useTenantsQuery,
    useCreate: useCreateTenantWrapper,
    useUpdate: useUpdateTenantWrapper,
    useDelete: useDeleteTenantWrapper,
  },

  table: {
    title: 'Universities',
    columns: [
      { key: 'name', label: 'Name' },
      { key: 'code', label: 'Code', render: (value) => value || '' },
      { key: 'description', label: 'Description', render: (value) => value || null },
      {
        key: 'createdAt',
        label: 'Created',
        render: (value) => (value ? new Date(value).toLocaleDateString() : null),
      },
    ],
    emptyMessage: 'No universities found',
    errorMessage: 'Failed to load universities. Please try refreshing the page.',
  },

  actions: {
    create: {
      label: 'Add University',
      dialog: AddTenantDialog,
    },
    edit: {
      label: 'Edit',
    },
    delete: {
      label: 'Delete',
      confirmTitle: 'Delete University',
      confirmMessage: (tenant) =>
        `Are you sure you want to delete "${tenant.name}"? This action cannot be undone.`,
    },
  },

  features: {
    search: true,
    pagination: true,
    onRowClick: (tenant) => {
      navigate(`/app/manage/universities/${tenant.id}`);
    },
  },
});

// Legacy export for backward compatibility
export const universitiesConfig = createUniversitiesConfig(() => {
  window.location.href = window.location.pathname; // Fallback
});
